/** Per-kind config for bond-creation basic information steps (Phase 9.8D). */

export const BOND_BASIC_INFO_CONFIG = {
  guardianship: {
    bondKind: "guardianship",
    logContext: "GuardianshipBasicInformation",
    showCounty: true,
    bondSubCategoryOptions: [
      "Guardian - Incapacitated",
      "Guardian - Minor",
      "Guardian - Advocate",
      "Conservator",
    ],
    nameFields: {
      mode: "split",
      firstLabel: "Ward Legal First Name",
      middleLabel: "Ward Legal Middle Name",
      lastLabel: "Ward Legal Last Name",
      aliasesLabel: "Ward Aliases",
      maxLength: 200,
      showSuffix: true,
      showAliases: true,
      aliasesMaxLength: undefined,
    },
    dateField: { name: "dateOfDeath", label: "Date of Birth" },
    principalField: { name: "GuardianNumber", label: "Number Of Guardians" },
    courtCaseNumberLabel: "Court Case Number",
    premiumStrategy: "guardianship",
    defaultCountField: "GuardianNumber",
    minorAgeValidation: true,
    esignatureMode: "none",
  },
  probate: {
    bondKind: "probate",
    logContext: "ProbateBasicInformation",
    showCounty: true,
    supportsLayoutView: true,
    bondSubCategoryOptions: [
      "Administrator",
      "Conservator",
      "Curator",
      "Executor",
      "Personal Representative",
    ],
    nameFields: {
      mode: "split",
      firstLabel: "Deceased Legal First Name",
      middleLabel: "Deceased Legal Middle Name",
      lastLabel: "Deceased Legal Last Name",
      aliasesLabel: "Aliases",
      maxLength: 50,
      showSuffix: true,
      showAliases: true,
      aliasesMaxLength: 150,
    },
    dateField: { name: "dateOfDeath", label: "Date of Death" },
    principalField: { name: "PrincipalNumber", label: "Number Of Principals" },
    courtCaseNumberLabel: "Court Case Number",
    premiumStrategy: "standard",
    defaultCountField: "PrincipalNumber",
    probateCountyConditionals: true,
    judgeSternLabel: "Has the Judge issued his order requiring bond yet?",
    splitByRepresentatives: true,
    esignatureMode: "threshold",
    esignatureThreshold: 50001,
  },
  trustee: {
    bondKind: "trustee",
    logContext: "TrusteeBasicInformation",
    showCounty: true,
    nameFields: {
      mode: "trustee",
      legalNameLabel: "Full Legal Name of Ward/Beneficiary  ",
      trustNameLabel: "Formal Name of the Trust",
    },
    dateField: { name: "dateOfBirth", label: "Date of Birth of Ward/Beneficiary" },
    principalField: { name: "PrincipalNumber", label: "Number Of Principals" },
    courtCaseNumberLabel: "Court File #",
    premiumStrategy: "standard",
    defaultCountField: "PrincipalNumber",
    esignatureMode: "always",
  },
  va: {
    bondKind: "va",
    logContext: "VABasicInformation",
    showCounty: false,
    nameFields: {
      mode: "split",
      firstLabel: "Beneficiary Legal First Name",
      middleLabel: "Beneficiary Legal Middle Name",
      lastLabel: "Beneficiary Legal Last Name",
      aliasesLabel: "Aliases",
      maxLength: 200,
      showSuffix: true,
      showAliases: true,
      aliasesMaxLength: 150,
    },
    dateField: { name: "dateOfBirth", label: "Date of Birth" },
    principalField: { name: "PrincipalNumber", label: "Number Of Principals" },
    courtCaseNumberLabel: "VA File #",
    premiumStrategy: "standard",
    defaultCountField: "PrincipalNumber",
    esignatureMode: "always",
  },
};
